<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">Create New Bank</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">Bank Information</span>
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Bank Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.bankName" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Branch Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.branchName" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Short Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.shortName" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Account Title</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.accountTitle" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Branch Code</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.branchCode" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Account Number</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.accountNumber" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">IBAN Number</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.ibanNumber" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label" for="default-01">Swift Code</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.swiftCode" type="text" class="form-control" id="default-01">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Contact Person</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.contactPerson" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Manager Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.managerName" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Contact Person Number</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.contactPersonNumber" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Account Type</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="newBank.accountType" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Status</label> <br />
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="newBank.isActive">
                                                    <label class="custom-control-label" for="customSwitch1">Active</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Location</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="newBank.location" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <div class="row gy-4 ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;"> Save</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { required} from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default ({
        components: {
            Loading
        },
        name: 'newBank',
        data: function () {
            return {
                loading: false,
                newBank: {
                    id: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    bankName: '',
                    isActive: true,
                    branchName: '',
                    branchCode: '',
                    accountNumber: '',
                    ibanNumber: '',
                    swiftCode: '',
                    location: '',
                    contactPerson: '',
                    managerName: '',
                    contactPersonNumber: '',
                    accountType: '',
                    shortName: '',
                    accountTitle: '',
                }
            }
        },
        validations: {
            newBank:
            {
                bankName:
                {
                    required
                }
            }
        },

        methods: {
            GoToList: function () {
                this.$router.push('/Bank')
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Company/SaveBank', this.newBank, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Created!',
                                text: 'Data has been Saved successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

        },
        created: function () {
            
            if (this.$route.query.data != undefined) {
                this.newBank = this.$route.query.data;
            }
        },
    })
</script>
